import { Flex } from 'antd';
import { memo, useContext } from 'react';

import { ServiceCode } from '@/shared/types';
import { ButtonVariant, Button, ConditionView, Modal, Typography } from '@/shared/ui';

import { SERVICE_CODES } from '@/lib/consts';
import { redirectToInternalServices } from '@/helpers/route';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { Button as ButtonLegacy } from '../../Button';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './PayOrLeaveAlert.scss';

export interface PayOrLeaveAlertProps {
  variant?: 'new' | 'legacy';
  serviceCode?: ServiceCode;
  closable?: boolean;
  payButtonAction: () => void;
  onDeleteCallback: () => void;
}

export const PayOrLeaveAlert = memo<PayOrLeaveAlertProps>(function ({
  variant = 'legacy',
  serviceCode = null,
  closable = true,
  payButtonAction,
  onDeleteCallback,
}) {
  const { isModalOpen, toggleModal } = useContext(ModalContext);

  const handleClose = (): void => {
    toggleModal(false);
    redirectToInternalServices();
  };

  return (
    <ConditionView
      if={variant === 'legacy'}
      else={
        <Modal
          open={isModalOpen}
          className="pay-or-leave-alert-modal"
          closable={closable}
          title={
            <>
              У вас вже є створений запит,
              <br />
              який очікує на оплату
            </>
          }
          footer={
            <Flex gap={16} className="pay-or-leave-alert__footer">
              <Button
                onClick={() => {
                  toggleModal(false);
                  payButtonAction();
                }}
              >
                Оплатити
              </Button>
              <Button
                variant={ButtonVariant.ERROR}
                onClick={() => {
                  toggleModal(false);
                  onDeleteCallback();
                }}
              >
                Видалити запит
              </Button>
            </Flex>
          }
          onCancel={handleClose}
        >
          <Typography color="black">Оплатіть або зачекайте на анулювання запиту впродовж 14 днів</Typography>
        </Modal>
      }
    >
      <ModalConstructor closable={closable} modalBorderTopColor={ModalBorderTopColor.blue} onCancel={handleClose}>
        <div className="pay-modal">
          <div className="pay-modal__title">У вас вже є створений запит, який очікує на оплату</div>

          <div className="pay-modal__primary-text">
            {serviceCode && serviceCode === SERVICE_CODES.INSURANCE
              ? 'Щоб завершити його оформлення, необхідно оплатити до кінця поточної доби'
              : 'Оплатіть або зачекайте на анулювання запиту впродовж 14 днів'}
          </div>

          <div className="pay-modal__buttons-box">
            <ButtonLegacy
              outline
              bgColor="error"
              onClick={() => {
                toggleModal(false);
                onDeleteCallback();
              }}
            >
              Видалити запит
            </ButtonLegacy>
            <ButtonLegacy
              onClick={() => {
                toggleModal(false);
                payButtonAction();
              }}
            >
              Оплатити
            </ButtonLegacy>
          </div>
        </div>
      </ModalConstructor>
    </ConditionView>
  );
});
